<script setup lang="ts">
import { setConfig } from '@barbanet/api-service'
import { useAppConfig } from '@barbanet/app-config'
import { UserStatusCheck } from '@barbanet/user-status-check'

import { useAccountStore } from './stores/account-store'

const { apiServer, appVersion, apiServerDefaultVersion } = useAppConfig()
const accountStore = useAccountStore()

setConfig({
	apiServer,
	appVersion: appVersion || undefined,
	apiServerDefaultVersion,
	credentials:
		accountStore.isLoggedIn && accountStore.credentials
			? {
					accessToken: accountStore.credentials.accessToken,
					refreshToken: accountStore.credentials.refreshToken
				}
			: null,
	onRefreshToken(newCredentials) {
		accountStore.setCredentials(newCredentials)
	},
	onRevokeToken() {
		accountStore.logout()
	}
})
</script>

<template>
	<BLayout>
		<BSnackbarQueue />
		<UserStatusCheck />

		<RouterView />
	</BLayout>
</template>
